<template>
  <div>
    <table cellpadding="0" cellspacing="0">
      <tr>
        <td colspan="13" width="1492">雾森文明-导航页[01]</td>
      </tr>
      <tr>
        <td rowspan="13" width="68">雾森<br />
          文化</td>
        <td @click="tabName('02')">雾森前言[02]</td>
        <td colspan="9" rowspan="10">
          <span @click="tabName(10)">人生道路[10]</span><br /><br />
          <span @click="tabName(11)">人身由来[11]</span><br /><br />
          <span @click="tabName(12)">十二生肖[12]</span><br /><br />
          <span @click="tabName(13)">人生寿命[13]</span><br /><br />
          <span @click="tabName('04')">能力体系[04]</span>-
          <span @click="tabName('05')">评价体系[05]</span>-
          <span @click="tabName('06')">境界体系[06]</span>-
          <span @click="tabName('07')">思维体系[07]</span>-
          <span @click="tabName('08')">悟性体系[08]</span><br /><br />
          <span @click="tabName(14)">能力段位[14]</span><br /><br />
          <span @click="tabName(15)">职业规划[15]</span><br /><br />
          <span @click="tabName(16)">人生定位[16]</span><br /><br />
          <span @click="tabName(18)">薪资体系[18]</span>-
          <span @click="tabName(24)">人文体系[24]</span>-
          <span @click="tabName(30)">文明体系[30]</span>-
          <span @click="tabName(36)">法治体系[36]</span>-
          <span @click="tabName(42)">价值体系[42]</span>-
          <span @click="tabName(48)">商道体系[48]</span>-
          <span @click="tabName(54)">商业体系[54]</span>-
          <span @click="tabName(60)">慈善体系[60]</span>-
          <span @click="tabName(66)">商道标识[66]</span>

        </td>
        <td colspan="2" @click="tabName('02')">使命共和[02]</td>
      </tr>
      <tr>
        <td rowspan="3" width="100" @click="tabName('09')">TTC-信仰[09]</td>
        <td @click="tabName(10)">我是谁[10]</td>
        <td rowspan="3" width="68" @click="tabName('09')">物质<br />
          层面<br />
          [09]</td>
      </tr>
      <tr>
        <td @click="tabName(11)">从哪来[11]</td>
      </tr>
      <tr>
        <td @click="tabName(12)">到哪去[12]</td>
      </tr>
      <tr>
        <td rowspan="3" @click="tabName('03')">TTC-境界[03]</td>
        <td @click="tabName(13)">我是谁[13]</td>
        <td rowspan="3" width="68" @click="tabName('03')">精神<br />
          层面<br />
          [03]</td>
      </tr>
      <tr>
        <td @click="tabName('04')">从哪来[04-08]</td>
      </tr>
      <tr>
        <td @click="tabName(14)">到哪去[14]</td>
      </tr>
      <tr>
        <td rowspan="3" @click="tabName(17)">TTC-共生[17]</td>
        <td @click="tabName(15)">我是谁[15]</td>
        <td rowspan="3" width="68" @click="tabName(17)">社会<br />
          层面<br />
          [17]</td>
      </tr>
      <tr>
        <td @click="tabName(16)">从哪来[16]</td>
      </tr>
      <tr>
        <td @click="tabName(18)">到哪去[18-71]</td>
      </tr>
      <tr>
        <td rowspan="3" @click="tabName(72)">雾森后语[72]</td>
        <td colspan="9" rowspan="3" width="1093">
          <table class="uls">
            <tr>
              <td class="uls-list">
                <span @click="tabName(19)">研发薪资[19]</span><br />
                <span @click="tabName(20)">生产薪资[20]</span><br />
                <span @click="tabName(21)">行政薪资[21]</span><br />
                <span @click="tabName(22)">销售薪资[22]</span><br />
                <span @click="tabName(23)">客服薪资[23]</span><br />
              </td>
              <td class="uls-list">
                <span @click="tabName(25)">组织架构[25]</span><br />
                <span @click="tabName(26)">管理辈分[26]</span><br />
                <span @click="tabName(27)">人格分类[27]</span><br />
                <span @click="tabName(28)">三教九流[28]</span><br />
                <span @click="tabName(29)">人际关系[29]</span><br />
              </td>
              <td class="uls-list">
                <span @click="tabName(31)">社会道路[31]</span><br />
                <span @click="tabName(32)">管理格局[32]</span><br />
                <span @click="tabName(33)">管理总则[33]</span><br />
                <span @click="tabName(34)">行为公约[34]</span><br />
                <span @click="tabName(35)">企业宪纲[35]</span><br />
              </td>
              <td class="uls-list">
                <span @click="tabName(37)">企业宪法[37]</span><br />
                <span @click="tabName(38)">信用积分[38]</span><br />
                <span @click="tabName(39)">行为政治[39]</span><br />
                <span @click="tabName(40)">法律制裁[40]</span><br />
                <span @click="tabName(41)">民主专政[41]</span><br />
              </td>
              <td class="uls-list">
                <span @click="tabName(43)">技术等级[43]</span><br />
                <span @click="tabName(44)">独立指数[44]</span><br />
                <span @click="tabName(45)">共产工分[45]</span><br />
                <span @click="tabName(46)">立项标准[46]</span><br />
                <span @click="tabName(47)">决算流程[47]</span><br />
              </td>
              <td class="uls-list">
                <span @click="tabName(49)">商道模型[49]</span><br />
                <span @click="tabName(50)">商道文明[50]</span><br />
                <span @click="tabName(51)">商道数理[51]</span><br />
                <span @click="tabName(52)">商道说字[52]</span><br />
                <span @click="tabName(53)">商道新风[53]</span><br />
              </td>
              <td class="uls-list">
                <span @click="tabName(55)">企业文化[55]</span><br />
                <span @click="tabName(56)">管理秩序[56]</span><br />
                <span @click="tabName(57)">阶级定义[57]</span><br />
                <span @click="tabName(58)">商品定价[58]</span><br />
                <span @click="tabName(59)">共和基金[59]</span><br />
              </td>
              <td class="uls-list">
                <span @click="tabName(61)">教育体系[61]</span><br />
                <span @click="tabName(62)">医疗体系[62]</span><br />
                <span @click="tabName(63)">金融体系[63]</span><br />
                <span @click="tabName(64)">安居体系[64]</span><br />
                <span @click="tabName(65)">养老体系[65]</span><br />
              </td>
              <td class="uls-list">
                <span @click="tabName(67)">商道国旗[67]</span><br />
                <span @click="tabName(68)">商道国歌[68]</span><br />
                <span @click="tabName(69)">商道国徽[69]</span><br />
                <span @click="tabName(70)">商道商标[70]</span><br />
                <span @click="tabName(71)">商道徽章[71]</span><br />
              </td>
            </tr>
          </table>
        </td>
        <td colspan="2" rowspan="3" @click="tabName(72)">宗教信仰[72]</td>
      </tr>
      <tr> </tr>
      <tr> </tr>
      <tr>
        <td rowspan="2" width="68">悟生<br />
          文化</td>
        <td @click="tabName(73)">悟生前言[73]</td>
        <td colspan="9" rowspan="2" width="1093"><span @click="tabName(74)">家族法制[74]</span> -<span @click="tabName(75)">股权分配[75]</span>-<span
            @click="tabName(76)">人生使命[76]</span></td>
        <td colspan="2" @click="tabName(73)">家族共和[73]</td>
      </tr>
      <tr>
        <td @click="tabName(77)">悟生后语[77]</td>
        <td colspan="2" @click="tabName(77)">天下为公[77]</td>
      </tr>
      <tr>
        <td rowspan="2" width="68">戊申<br />
          文化</td>
        <td @click="tabName(78)">戊申前言[78]</td>
        <td colspan="9" rowspan="2" width="1093" @click="tabName(79)">共和报表[79]</td>
        <td colspan="2" @click="tabName(78)">文明共和[78]</td>
      </tr>
      <tr>
        <td @click="tabName(80)">戊申后语[80]</td>
        <td colspan="2" @click="tabName(80)">人生意义[80]</td>
      </tr>
      <tr>
        <td colspan="13" width="1492" @click="tabName(81)">《雾森文明》工程进度计划表[81]</td>
      </tr>
      <tr>
        <td colspan="13" width="1492" @click="goChina">《中国文明》简史暨黄帝二十八元运总览图</td>
      </tr>
    </table>

  </div>
</template>

<script setup>
import { getName } from "@/api/culture.js";

import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
const router = useRouter()
const store = useStore()
const tabName = async (val) => {
  const data = {
    name: val + ' TTC'
  }
  const backData = await getName(data)
  store.commit('tabCultureActive', backData.data.cate_id)
  router.push({
    path: `/culture/cate${backData.data.cate_id}`,
    query: {
      id: backData.data.id
    }
  })
}

// 跳转中国文明页面
const goChina = () => {
  router.push('/culture/cate5')
  store.commit('tabCultureActive', 5)
}

</script>

<style lang="scss" scoped>
table{
  width: 100%;
  text-align: center;
  font-size: 8px;
  td{
    border: 1Px solid #000;
  }
}
.uls{
  margin: 0 auto;
  .uls-list {
    border: none;
    border-right: 1px solid #000;
    padding: 2px;
    text-align: center;
    &:nth-child(1) {
      border-left: 0;
    }
    &:nth-last-child(1) {
      border-right: 0;
    }
    border-top: 0;
    border-bottom: 0;
  }
}
span{
  font-size: 8px;
}
</style>